// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.half-content-card-modal-gs{
    position: relative;
    width: 50%;
    height: 100%;
    display: block;
    justify-content: center;
    align-items: center;
}
.center-content-card-modal-gs{
    position: relative;
    width: 90%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content-row-host-selected{
    position:relative;
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: red; */
}
.row-host-selected{
    position:relative;
    height: 70%;
    width: 80%;
    border-radius: var(--border-radios-small);
    border: 1px solid var(--border-table-color);
    background-color: rgba(209, 209, 209, 0.281);
    display: flex;
    justify-content: center;
    align-items: center;
}
.text-host-selected{
    position:relative;
    height: 100%;
    width: 90%;;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: var(--txt-color);
    font-size: var(--font-size-xSmall);
}
.delete-host-selected{
    position:relative;
    height: 100%;
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--red-alert);
    font-size: var(--font-size-xSmall);
}
.delete-host-selected:hover{
cursor: pointer;
font-size: var(--font-size-med);
}
.txtdevicesSelected{
    position: relative;
    height: 100%;
    width: 50%;
    color: var(--txt-color);
    font-size: var(--font-size-small);

}`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/Software/styles/ModalAddHost.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,yCAAyC;IACzC,2CAA2C;IAC3C,4CAA4C;IAC5C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;AACtC;AACA;AACA,eAAe;AACf,+BAA+B;AAC/B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,iCAAiC;;AAErC","sourcesContent":[".half-content-card-modal-gs{\n    position: relative;\n    width: 50%;\n    height: 100%;\n    display: block;\n    justify-content: center;\n    align-items: center;\n}\n.center-content-card-modal-gs{\n    position: relative;\n    width: 90%;\n    height: 90%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.content-row-host-selected{\n    position:relative;\n    height: 50px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* background-color: red; */\n}\n.row-host-selected{\n    position:relative;\n    height: 70%;\n    width: 80%;\n    border-radius: var(--border-radios-small);\n    border: 1px solid var(--border-table-color);\n    background-color: rgba(209, 209, 209, 0.281);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.text-host-selected{\n    position:relative;\n    height: 100%;\n    width: 90%;;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    color: var(--txt-color);\n    font-size: var(--font-size-xSmall);\n}\n.delete-host-selected{\n    position:relative;\n    height: 100%;\n    width: 10%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--red-alert);\n    font-size: var(--font-size-xSmall);\n}\n.delete-host-selected:hover{\ncursor: pointer;\nfont-size: var(--font-size-med);\n}\n.txtdevicesSelected{\n    position: relative;\n    height: 100%;\n    width: 50%;\n    color: var(--txt-color);\n    font-size: var(--font-size-small);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
